var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6520_23459)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66634 1.83337C4.44468 1.83337 1.83301 4.44505 1.83301 7.66671C1.83301 10.8884 4.44468 13.5 7.66634 13.5C10.888 13.5 13.4997 10.8884 13.4997 7.66671C13.4997 4.44505 10.888 1.83337 7.66634 1.83337ZM0.833008 7.66671C0.833008 3.89276 3.8924 0.833374 7.66634 0.833374C11.4403 0.833374 14.4997 3.89276 14.4997 7.66671C14.4997 9.37372 13.8738 10.9345 12.8389 12.1322L15.0199 14.3132C15.2152 14.5084 15.2152 14.825 15.0199 15.0203C14.8246 15.2155 14.5081 15.2155 14.3128 15.0203L12.1318 12.8393C10.9342 13.8741 9.37335 14.5 7.66634 14.5C3.8924 14.5 0.833008 11.4407 0.833008 7.66671Z",
    fill: "#0D0D0D",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6520_23459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.916ff5347204c7fa680cdbc03e4947bb.svg";
export { ForwardRef as ReactComponent };